import { InputLabel, inputLabelClasses, styled } from '@mui/material';
import { config } from 'public/styles/config';

export const StyledFormInputLabel = styled(InputLabel)(({ theme }) => ({
  [`&.${inputLabelClasses.root}`]: {
    fontSize: theme.typography.pxToRem(16),
    color: config.colors.text.secondary,
    marginBottom: theme.spacing(3),
    fontVariationSettings: '"wght" 500',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '100%',
  },
}));
